import { useEffect } from 'react';
import { trackEvent } from '@shared/utils/eventTrack';
import useProject from '@API/project/useProject';
import { viewEvents } from '@/constants/trackingEventTypes';
import { useCurrentPaymentPlan } from '@shared/hooks';
import { useParams } from 'react-router';
import { DashboardRouteParams } from '@experiment-management-shared/types';
import useDashboardPageSectionName from '@projects/hooks/useDashboardPageSectionName';

const useProjectViewedBI = () => {
  const section: string = useDashboardPageSectionName();
  const { projectName, workspace } = useParams<DashboardRouteParams>();
  const { data: project, isLoading: isLoadingProject } = useProject();
  const { paymentPlanName } = useCurrentPaymentPlan();

  useEffect(() => {
    if (isLoadingProject) return;

    trackEvent(viewEvents.PROJECT_VIEWED, {
      canEdit: project?.canEdit,
      isArchive: section === 'archive',
      projectId: project?.projectId,
      projectName,
      workspace,
      workspacePlan: paymentPlanName
    });
  }, [
    isLoadingProject,
    project?.canEdit,
    project?.projectId,
    projectName,
    workspace,
    paymentPlanName,
    section
  ]);
};

export default useProjectViewedBI;
